function asYupResolverSchema(schema) {
    return schema;
}
export { asYupResolverSchema };
